import React, { useEffect, useState } from "react";
import "./ScHeaderComp.css";
import ReactDOM from "react-dom";
import AddToMemoryComp from "../../../../Navigation/memoryComps/AddToMemoryComp";
import { handleRefreshMem } from "../../../../../services/iqApiV2";
import { useParams, useSearchParams } from "react-router-dom";
import IOSSpinner from "../../../../HtmlElements/IOSSpinner";
import { useWebSocket } from "../../../uiUtils/useWebSocket";
import { useTaskStatus } from "../../../../../context/TaskStatusContext";
import MemoryHistoryListComp from "../../../../Navigation/memoryComps/MemoryHistoryListComp";
import { useDispatch } from "react-redux";
import { listGlobalMemRequest } from "../../../../../store/features/actions/memory/globalMemoryActions";
import { useUser } from "../../../../../context/UserContext";
import ReviewComponent from "../../../../HtmlElements/ReviewComponent";
import { fetchReviewSectionEntityList } from "../../../../../services/commonService";
import { WSS_URL } from "../../../../../config/apiConfig";
function ScHeaderComp({
  data,
  type = null,
  titlkey = "opportunity_name",
  titlTxt,
  showMoreModal,
  setShowMoreModal = { setShowMoreModal },
  opportunityId,
  tabConfig,
  showMemComp=false,
  memoryType
}) {
    const {user} = useUser();
  const { accountId, accountName, clientName } = useParams();
  const [likeStatus, setLikeStatus] = useState("")

  const { registerTask, getTaskStatus } = useTaskStatus();
  const [openAddmem, setOpenAddMem] = useState(false);
  useEffect(() => {
    if (!showMoreModal) {
      setOpenAddMem(false);
    }
  }, [showMoreModal]);
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTabFromUrl = searchParams.get("tab");
  const [refreshLoading, setRefreshLoading] = useState(false);
  const dispatch=useDispatch();
  useEffect(() => {

    if (openAddmem) {
      dispatch(listGlobalMemRequest({userId:user?.id,memoryType:'single-oportunity',opportunityId}))
    }
    
  }, [openAddmem])
  
  const [selectedChips,setSelectedChips]=useState([]);

  const handleRefreshMemory = async (e) => {
    e.preventDefault();
    setRefreshLoading(true);
    const  resp = await handleRefreshMem({ opportunityId });
    setRefreshLoading(false);
      if (resp) {
        const wsEndpoints = {
          battle_card: "opp_sidecard_battle_card",
          business_case_slide: "opp_sidecard_business_case_slide",
          contact_map: "opp_sidecard_contact_map",
          news: "opp_sidecard_news",
          next_step: "opp_sidecard_next_step",
          value_selling_prompter: "opp_sidecard_value_selling_prompter"
        };
      
        Object.entries(wsEndpoints).forEach(([key, prefix]) => {
          if (resp?.[key]) {
            registerTask(
              `${prefix}_${opportunityId}`,
              `${WSS_URL}/${resp[key]}`
            );
          }
        });
      }
      
  
  };

  useEffect(() => {
    const fetchReviewData = async () => {
      if (type && opportunityId) {
        const like_list = await fetchReviewSectionEntityList(accountName, clientName, type, opportunityId);
        if (like_list?.[0]?.is_liked) {
          setLikeStatus(like_list?.[0]?.is_liked);
        }
      }
    };
    fetchReviewData();
  }, [type, opportunityId]);

  return (
    <div className="sc-card-header-wrapper" key={`side_card_head_${opportunityId}`} >
      <div className="back_arrow_name">
        <img
          src="/img/backArrow.png"
          className="back_arrow cursorP"
          onClick={() => setShowMoreModal()}
        />
        <div className="back_head_block">
          <h5 className="back_head">{titlTxt ? titlTxt : data?.[titlkey]}</h5>
        </div>
      </div>

      <div className="right_side_btn_block">
        {type != "incDS" && (
          <>
            <ReviewComponent reviewObj={
                {
                  "section": type,
                  "entity_code": opportunityId,
                  "entity_name": titlTxt ? titlTxt : (data?.[titlkey] || ''),
                  "like_status": likeStatus,
                }
            } />
            {/* <div className="thumbs_block">
              <img src="/img/thumbs-up.svg" className="top_icon" />
              <img src="/img/thumbs-down.svg" className="top_icon" />
            </div>
            <div className="divided_block">
              <span className="divided">|</span>
            </div>
            <div className="thumbs_block">
              <img src="/img/download.svg" className="top_icon" />
            </div> */}
            {/* <div className="divided_block">
              <span className="divided">|</span>
            </div>
            <div className="thumbs_block">
              <img src="/img/share-2.svg" className="top_icon" />
            </div>
            <div className="divided_block">
              <span className="divided">|</span>
            </div> */}
          </>
        )}
        {showMemComp && (
          <>
            <button
              className="memory_btn_trans"
              onClick={(e) => setOpenAddMem((prev) => !prev)}
            >
              <img src="/img/plus1.png" className="memory_icon" />
              Memory
            </button>
            <button
              className="memory_btn"
              onClick={(e) => handleRefreshMemory(e)}
            >
              <img src="/img/refresh.svg" className="memory_icon" />
              {refreshLoading ? (
                <>
                  <IOSSpinner />
                </>
              ) : (
                "Memory"
              )}
            </button>
          </>
        )}
      </div>

      {openAddmem &&
        ReactDOM.createPortal(
          <div
            style={{
              borderRadius: "1rem",
              boxShadow: "0 0.5rem 2rem rgba(0, 0, 0, 0.15)",
              zIndex: 1500,
              maxWidth: "30rem",
              maxHeight: "50rem",
              position: "fixed",
              top: "3.5rem",
              right: "6.5rem",
              overflow: "hidden",
              // optional for spacing
            }}
          >
            <AddToMemoryComp
              memoryType={memoryType}
              opportunityId={opportunityId}
              selectedChips={selectedChips} setSelectedChips={setSelectedChips}
              tabConfig={tabConfig}
            />
            <MemoryHistoryListComp  memoryType={memoryType}/>
          </div>,
          document.body
        )}
    </div>
  );
}

export default ScHeaderComp;
